const getDomain = (): string => {
  const {
    location: { hostname },
  } = window;
  const domain = hostname
    .split('.')
    .reverse()
    .splice(0, 2)
    .reverse()
    .join('.');
  return `; domain=.${domain}`;
};

export const setCookie = (name: string, value: string, days?: number): void => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}${getDomain()};path=/`;
};

export const eraseCookie = (name: string): void => {
  document.cookie = `${name}=;${getDomain()}; path=/;`;
};

/**
 * Check if cookie consent is in URL. When user comes
 * to booking system from WordPress site, the cookie consent
 * is read from CookieBot plugin and set to URL parameters.
 * @param string search string
 * @returns true if all cookie parameters are included in url
 */
export const isConsentInURLParams = (searchString: string): boolean => {
  const searchParams = new URLSearchParams(searchString);
  const consentParams = [
    'preferences',
    'statistics',
    'marketing',
    'doNotTrack',
  ];

  return consentParams.every((param) => searchParams.has(param));
};

export const defaultConsent = {
  preferences: false,
  statistics: false,
  marketing: false,
  doNotTrack: false,
};

/**
 * When user comes to booking system from WordPress site,
 * the cookie consent is read from CookieBot plugin and then
 * set to URL parameters. This function reads those consent
 * values from search string and returns an object representing
 * cookie consent. If some value is not exactly 'true', it's set
 * to false.
 * @param string search string
 * @returns CookieConsent object
 */
export const getConsentFromSearchString = (
  searchString: string,
): CookieConsent => {
  if (!searchString) return defaultConsent;
  const params = new URLSearchParams(searchString);

  return {
    preferences: params.get('preferences') === 'true',
    statistics: params.get('statistics') === 'true',
    marketing: params.get('marketing') === 'true',
    doNotTrack: params.get('doNotTrack') === 'true',
  };
};
